import { useState } from 'react';
import type { Ride } from '../../domain/ride';
import type { StudioDraft } from '../studio-draft';
import { freshStudioEdit, loadEditVersions, saveEditVersion, type EditVersion } from '../edit-versions';

export function EditVersions({ ride, draft, disabled, onChange }: {
  ride: Ride; draft: StudioDraft; disabled: boolean; onChange: (draft: StudioDraft) => boolean;
}) {
  const [versions, setVersions] = useState<EditVersion[]>(() => {
    try { return loadEditVersions(ride); } catch { return []; }
  });
  const [message, setMessage] = useState('');
  const change = (next: StudioDraft) => {
    try {
      setVersions(saveEditVersion(ride, draft));
      setMessage(onChange(next) ? 'Previous edit saved in this browser.' : 'Previous edit saved. The active edit could not be saved; check the storage message.');
    } catch { setMessage('The previous edit could not be saved. Your current edit has been kept.'); }
  };
  return <section aria-label="Edit versions">
    <button type="button" className="trace-panel-action" disabled={disabled} onClick={() => change(freshStudioEdit(draft))}>Clear all keyframes</button>
    <p>Keep your trace, appearance, and output settings. Restore the prior version from Previous edits in this browser.</p>
    {versions.length > 0 && <label>Previous edits<select aria-label="Previous edits" value="" disabled={disabled} onChange={event => {
      const version = versions.find(item => item.id === event.target.value); if (version) change(version.draft);
    }}><option value="">Restore a saved edit…</option>{versions.map((version, index) => <option key={version.id} value={version.id}>{version.draft.title} · {new Date(version.savedAt).toLocaleString()} · {versions.length - index}</option>)}</select></label>}
    {message && <p role="status">{message}</p>}
  </section>;
}
